// src/utils/ConfirmationModal.jsx
import React from 'react';
import { createPortal } from 'react-dom';

const ConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = "Confirm",
  confirmButtonClass = "btn-primary",
  cancelButtonText = "Cancel",
  showCancel = true,
  bodyContent,
  scrollable = false
}) => {
  if (!show) return null;

  return createPortal(
    <div className="modal fade show d-block bg-dark bg-opacity-50" style={{ zIndex: "var(--num-1000000000 )" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <p className="mb-0 ev-fs-15 ev-bold-med">
              {title}
            </p>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
            ></button>
          </div>
          <div className={`modal-body ev-fs-12${scrollable ? ' scrollable-element' : ''}`}>
            {message && <p>{message}</p>}
            {bodyContent && (
              <div>
                {bodyContent}
              </div>
            )}
          </div>
          <div className="modal-footer">
            {showCancel && (
              <button 
                type="button" 
                className="btn btn-secondary ev-btn-reg"
                onClick={onClose}
              >
                {cancelButtonText}
              </button>
            )}
            <button 
              type="button" 
              className={`btn ${confirmButtonClass} ev-btn-reg`}
              onClick={onConfirm}
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;